module.exports = __webpack_public_path__ + "/media/images/health-feature-first.png";


//////////////////
// WEBPACK FOOTER
// ./images/health-feature-first.png
// module id = 88
// module chunks = 9